module.exports = require('./FootNav.vue');


// WEBPACK FOOTER //
// ./src/components/Common/FootNav/index.js